<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title :class="classType">
          <div class="text-center">
            {{ title }}
          </div>
        </v-card-title>
        <div>
          <app-row
            v-for="index in details.length"
            :key="index"
            icon=""
            :title="details[index - 1].Fname"
            :value="normalizeNumber(details[index - 1].Mablagh)"
          />
          <hr class="separator" />
          <app-row icon="" title="جمع" :value="normalizeNumber(sumDetail)" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["details", "classType", "title"],
  components: {
    appRow: DetailRow,
  },
  /**
   * open hozoor list
   */

  computed: {
    sumDetail() {
      var res = 0;
      for (var i = 0; i < this.details.length; i++) {
        res += parseInt(this.details[i].Mablagh);
      }
      return res;
    },
  },
  methods : {
    normalizeNumber(number) {
      return this.numberWithCommas(number) + " ریال"
    }
  }
};
</script>
<style scoped>

.separator {
  margin: 15px;
  border: none;
  height: 3px;
  /* Set the hr color */
  color: #333; /* old IE */
  background-color: #333; /* Modern Browsers */
}
</style>
